export const columns = [
  {
    accessorKey: "name",
    header: "Warehouse Name",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "location",
    header: "Address/Location",
    type: "string",
    size: 200,
  },
  {
    accessorKey: "areaCovered",
    header: "Area Covered",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
